import React from 'react';

function Header() {
  return (
    <header className="App-header">
      <h1>Online Ceramics</h1>
      <p>
        <font face="times" size="2" color="black"><b>b. </b>2016</font>
      </p>

      <a href="https://hauntedwagon.com"><font face="arial" size="3" color="blue">HAUNTED WAGON HOME PAGE</font></a><font face="times" size="2" color="black"></font>

      <hr style={{border: '1px solid #020202'}} />

      <p>
        <small>To buy in person try these stores:</small>
        <br/>
        <font face="times" size="3" color="black">
          <b>Union </b>Los Angeles/Tokyo
          or <b>GR8 </b>Tokyo
          or <b>Dover Street Market</b> London/New York City/Los Angeles
          or <b>Video EYE</b> New York City
          or <b>CLASSIC HITS</b> Los Angeles
        </font>
      </p>

      <p><b><font face="times" size="3" color="black">
        ONLINECERAMICS.HQ@GMAIL.COM - ORDER INQUIRIES
        <br/>
        ONLINECERAMICS@GMAIL.COM - PRESS INQUIRIES
        <br/>
      </font></b></p>

      <p><u><font face="arial" size="3" color="red"> <b>VERY IMPORTANT INFORMATION PLEASE READ TO AVOID CONFUSION :0)</b> </font></u></p>

      <p><font face="times" size="3" color="blue">
        *all tie dyes are unique & the images displayed
        <br/>
        most likely will not be the same as the shirt you receive
        <br/>
        Shirts are printed and dyed one by one :) so please be patient
        <br/>
        as it may take up to <b><mark>30 DAYS</mark></b> for your package to ship.
        <br/>
        deep gratitude for your support Jai Ma!
        <br/>
        please email us at <b>ONLINECERAMICS.HQ@GMAIL.COM</b>
        <br/>
        with questions about your purchase thank you!
      </font></p>

      <a href="/shipping"><font face="arial" size="3" color="Blue"> <u>Click Here For International Shipping Information</u></font></a>

      <p><u><font face="arial" color="black"> NO REFUNDS OR EXCHANGES ALL SALES FINAL PLEASE DOUBLE CHECK YOUR SIZE AND ADDRESS! thank you :)</font></u></p>

      <a href="/info"><font face="arial" size="3" color="blue">1. Info, </font></a><font face="times" size="2" color="black">Information on how to contact us! don't be shy :) </font>
      <br/>
      <a href="/links"><font face="arial" size="3" color="green">2. Links, </font></a><font face="times" size="2" color="black">A page of cool websites we're excited to share with you</font>
      <br/>
      <a href="/archive"><font face="arial" size="3" color="purple">3. Archive, </font></a><font face="times" size="2" color="black">Most of everything we've made so far :)</font>
      <br/>
      <a href="/friends"><font face="arial" size="3" color="red">4. Friends & Family, </font></a><font face="times" size="2" color="black">Our favorite page. Please send us your photos! We get so high sharing these pictures. </font>
      <br/>
      <a href="https://www.localharvest.org/csa/"><font face="arial" size="3" color="orange">5. Support Local Agriculture, </font></a><font face="times" size="2" color="black">Small organic farms need your help. You can help by subscribing to your local farm box program it's so special :) </font>
      <br/>
      <a href="https://www.bhaktiyogashala.com"><font face="arial" size="3" color="yellow">6. Bhakti Yoga Shala, </font></a><font face="times" size="2" color="black">One of our favorite places in LA. Life is the Course, Love is the Source. </font>

      <br/><br/>
      <hr style={{border: '1px solid #020202'}} />
    </header>
  );
}

export default Header;
